const EmptyEducatorState = () => {
  return (
    <svg
      width="98"
      height="98"
      viewBox="0 0 98 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1279_18362)">
        <circle cx="49" cy="49" r="49" fill="#808080" fillOpacity="0.2" />
        <path
          opacity="0.2"
          d="M121.91 73.78L101.037 104.432L90.697 78.3828L70.6001 109.604"
          stroke="#808080"
          strokeWidth="23.8519"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.2"
          d="M26.0767 -8.63669L5.20349 22.0148L-5.13645 -4.03391L-25.2334 27.1878"
          stroke="#808080"
          strokeWidth="23.8519"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.0002 46.1889C41.8962 46.1889 36.1373 40.4491 36.1373 33.3686C36.1373 26.2881 41.8962 20.5482 49.0002 20.5482C56.1043 20.5482 61.8632 26.2881 61.8632 33.3686C61.8632 40.4491 56.1043 46.1889 49.0002 46.1889ZM49.0003 77.3667C35.8273 77.3667 25.1484 66.6878 25.1484 53.5148V51.8349C25.1484 50.7397 26.0363 49.8518 27.1315 49.8518H70.8691C71.9643 49.8518 72.8521 50.7397 72.8521 51.8349V53.5148C72.8521 66.6878 62.1733 77.3667 49.0003 77.3667ZM59.9876 57.8586C58.4234 57.8586 57.1268 56.7309 56.8909 55.2564C56.8664 55.1437 56.856 55.0506 56.8588 54.9693C56.8588 54.9681 56.8589 54.9669 56.859 54.9657C56.8591 54.9645 56.8592 54.9634 56.8591 54.9622C56.8592 54.8554 56.937 54.7725 57.0448 54.7725H62.9331C63.041 54.7725 63.1188 54.8555 63.1188 54.9624C63.1229 55.0557 63.1094 55.1647 63.0768 55.301C62.8222 56.7536 61.536 57.8586 59.9876 57.8586ZM59.9783 58.4991C60.7604 58.4991 61.4088 59.0629 61.5267 59.8002C61.5389 59.8565 61.5441 59.9031 61.5427 59.9437C61.5428 59.9449 61.5425 59.9461 61.5426 59.9473C61.5425 60.0007 61.5036 60.0421 61.4497 60.0421H58.5056C58.4516 60.0421 58.4127 60.0006 58.4127 59.9472C58.4107 59.9005 58.4174 59.846 58.4337 59.7778C58.5611 59.0515 59.2042 58.4991 59.9783 58.4991Z"
          fill="#808080"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1279_18362">
          <path
            d="M0 49C0 21.938 21.938 0 49 0V0C76.062 0 98 21.938 98 49V49C98 76.062 76.062 98 49 98V98C21.938 98 0 76.062 0 49V49Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmptyEducatorState;
